export const BILLING_FEATURE_KEY = 'payments_integration'
